import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// VITE_AUTH=supabase serves the one app (Supabase email-link sign-in) with the old MSAL admin app
// under /admin; any other value keeps the old app at the root, as before.
const OneApp = lazy(() => import('./oneapp/OneApp').then((m) => ({ default: m.OneApp })));
const LegacyApp = lazy(() => import('./App'));

const oneApp = import.meta.env.VITE_AUTH === 'supabase';
const underAdmin = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={null}>
      {oneApp && !underAdmin ? <OneApp /> : <LegacyApp basename={oneApp ? '/admin' : undefined} />}
    </Suspense>
  </React.StrictMode>,
);
